import { gql } from 'graphql-request'
import type { Ref } from 'vue'
import type { ID } from '@/types/basic'
import { graphQLClient } from '../../gqlClient'

export const PAGE_LIMIT = 50

export const UNIQUE_VALUES_FIELDS = [
  'big_blind',
  'blinds',
  'file_original_name',
  'game_depth',
  'game_format',
  'game_rake',
  'game_table',
  'game_type',
  'game_variant',
  'player_nickname',
  'player_position',
  'player_winloss',
  'site',
  'small_blind',
  'solution_status',
  'id',
  'source',
  'preflop_game_depth',
]

export type FieldName = (typeof UNIQUE_VALUES_FIELDS)[number]

export const getUniqueValues =
  (valueId: FieldName) => async (): Promise<{ unique_values: Record<FieldName, (ID | ID[])[]> }> =>
    graphQLClient.request(gql`
  query Unique_values {
    unique_values{
      ${valueId}
    }
  }
  `)

// This filtering works only for string fields with SINGLE_CHOICE type
export const getUniquePaginatedValues =
  (valueId: FieldName, searchValue: Ref<string>, page: Ref<number>) =>
  async (): Promise<{
    unique_paginated_values: { items: Array<Record<FieldName, string | number>> }
  }> =>
    graphQLClient.request(gql`
    query Unique_paginated_values {
      unique_paginated_values(
        offset: ${page.value * PAGE_LIMIT},
        limit: ${PAGE_LIMIT},
        filtered_by: {
          ${valueId}__icontains: "${searchValue.value}"
        }
      ){
        items {
          ${valueId}
        }
      }
    }
    `)
